import { APICallV2Post } from './APICall';

export class TrashbinRestoreApiCall extends APICallV2Post {
    _method = 'trashbin/restore';
}
